module.exports = __webpack_public_path__ + "static/media/22769668_1629546660453852_6908195912378681301_o.db175863.jpg";